import { app, authentication } from "@microsoft/teams-js";
import { initializeTeamsApp } from "./teamsBootstrap";

/**
 * Teams SDK access service for the auth and context layer.
 *
 * Axios / SignalR should not know the details of `app.initialize()` — they use
 * this service, which guarantees the SDK is initialized before calling
 * `getAuthToken()` / `getContext()`.
 *
 * The Promise cache is used SOLELY to deduplicate concurrent in-flight requests.
 * It is not a permanent cache — `cleanup` resets the Promise both on success
 * and on failure.
 */

let tokenPromise: Promise<string> | null = null;

export function getAccessToken(): Promise<string> {
  if (tokenPromise) {
    return tokenPromise;
  }

  const promise = initializeTeamsApp().then(() => authentication.getAuthToken());

  tokenPromise = promise;

  const cleanup = () => {
    if (tokenPromise === promise) {
      tokenPromise = null;
    }
  };

  promise.then(cleanup, cleanup);

  return promise;
}

let contextPromise: Promise<app.Context> | null = null;

export function getContext(): Promise<app.Context> {
  if (contextPromise) {
    return contextPromise;
  }

  const promise = initializeTeamsApp().then(() => app.getContext());

  contextPromise = promise;

  const cleanup = () => {
    if (contextPromise === promise) {
      contextPromise = null;
    }
  };

  promise.then(cleanup, cleanup);

  return promise;
}
